// A site's departments, routing rules and assignment mode — mirrors
// packages/server/src/routes/routing.ts.

import { apiFetch } from './api';

export interface RuleConditions {
  pageContains?: string;
  countries?: string[];
  channels?: string[];
  keywords?: string[];
}

export interface RoutingSetup {
  assignmentMode: 'manual' | 'auto';
  departments: Array<{ id: string; name: string; agentIds: string[] }>;
  rules: Array<{ id: string; name: string; department: string; conditions: RuleConditions }>;
  /** Agents on the site, for department membership. */
  agents: Array<{ id: string; name: string }>;
}

export interface RoutingSave {
  assignmentMode: 'manual' | 'auto';
  departments: Array<{ id?: string; name: string; agentIds: string[] }>;
  rules: Array<{ name: string; department: string; conditions: RuleConditions }>;
}

export function fetchRouting(siteId: string): Promise<RoutingSetup> {
  return apiFetch(`/api/admin/sites/${encodeURIComponent(siteId)}/routing`);
}

export function saveRouting(siteId: string, body: RoutingSave): Promise<RoutingSetup> {
  return apiFetch(`/api/admin/sites/${encodeURIComponent(siteId)}/routing`, { method: 'PUT', body: JSON.stringify(body) });
}
